import React from 'react';
import { Grid, Typography } from '@material-ui/core';
import { InsertDriveFileOutlined } from '@material-ui/icons';
import { DraggableListItemHandle } from '@campfire/draggable-list';
import { HoverText } from '@campfire/hover-link';
import { useFormBuilderDialogContext, PageBreakTaskItemData } from '../../FormBuilderDialogContext';
import { useCampfireTheme } from '../../../../../../../../theme/useCampfireTheme';

interface Props {
  data: PageBreakTaskItemData;
}

export const PageBreakTaskItem = (props: Props) => {
  const { data } = props;
  const { editPageBreak } = useFormBuilderDialogContext();
  const { theme } = useCampfireTheme();

  return (
    <Grid
      container
      spacing={2}
      alignItems='center'
      style={{
        margin: 8,
        padding: '2px 0',
        borderTop: `1px solid ${theme.color.grey.neutralBrand200}`,
        borderBottom: `1px solid ${theme.color.grey.neutralBrand200}`,
      }}
    >
      <Grid item>
        <DraggableListItemHandle />
      </Grid>

      <Grid item style={{ display: 'flex', alignItems: 'center' }}>
        <InsertDriveFileOutlined style={{ fontSize: 18, color: theme.color.grey.neutral200 }} />
      </Grid>

      <Grid item>
        <Typography style={{ fontWeight: 500 }}>{data.title || 'Untitled page'}</Typography>
      </Grid>

      <Grid item container xs justify='flex-end'>
        <HoverText color='primary' onClick={() => editPageBreak(data)}>
          {'Edit Page'}
        </HoverText>
      </Grid>
    </Grid>
  );
};
